import { IStyle } from '@fluentui/react';

export interface ILineChartStyles {
  root: IStyle;
}

export interface ILineChartClassNames {
  root: string;
}

export const lineChartStylesDefault: Partial<ILineChartStyles> = {
  root: {
    height: '100%',
  },
};
